'use strict';
import {DevStackSelectable} from "./DevStackCriteria";
// -----------------------------------------------------------------------------------
/** Order direction */
export var DevStackOrderDirection = {
    ASC : "ASC",
    DESC : "DESC"
}

// -----------------------------------------------------------------------------------
/**
 * DevStack Order
 * @param column column
 * @param orderDirection
 * @constructor
 */
export var DevStackOrder = function(column, orderDirection){

    /** Managed column (String : column name)*/
    this.column = DevStackSelectable.create(column);

    /** Order direction */
    if (orderDirection == undefined)
        this.orderDirection = DevStackOrderDirection.ASC;
    else
        this.orderDirection = orderDirection;
}
